document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".btn--together").forEach(function (btn) {
        btn.addEventListener("click", function (e) {

            let href = btn.getAttribute("href");

            if (!href) return;

            // extract ID after #
            let targetId = null;

            if (href.includes("#")) {
                e.preventDefault();
                e.stopPropagation();
                targetId = href.split("#")[1]; // get only the part after #
            }

            if (targetId) {
                let targetElement = document.getElementById(targetId);

                if (targetElement) {
                    const topOffset = 160;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - topOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }
            }
        });
    });
});